<template>
    <router-view />
</template>
  
<script>
  export default {
    name: "MyDatas",
  };
</script>
  